import React, {useEffect, useState} from 'react';
import {TCategory, TSubCategory} from '../types/types';
import {getSubCategories} from '../apis/category';
import {useHistory} from 'react-router-dom';

type MobileCategoryItemProps = {
  category: TCategory;
};

export const MobileCategoryItem = (props: MobileCategoryItemProps) => {
  const {category} = props;
  const history = useHistory();
  const [open, setOpen] = useState<boolean>(false);
  const [subs, setSubs] = useState<TSubCategory[]>([]);

  useEffect(() => {
    getSubCategories(category.categoryId).then(r => setSubs(r.data.payload));
  }, [category]);

  return (
    <>
      <div className={`border-b py-4 
      ${category?.categoryName == "시즌오프" && ('BF_NAV')}
      ${category?.categoryName == "미드세일" && ('text-color-fe7b1e')} 
      `}
           onClick={() => setOpen(!open)}>
        <span className="mtn_hover" style={{fontWeight: open ? 600 : 400}}>
          {category.categoryName}
        </span>
      </div>
      {open && (
          <>
            <div
              className={`border-b py-4 ml-8`}
              // onClick={() => history.replace(`/p/${category.categoryName}/${category.categoryId}${category?.categoryName === '미드세일' ? '?midSale=true' : ''}`)}>
              onClick={() =>
                  history.replace(
                      `/p/${category.categoryName}/${category.categoryId}${category?.categoryName === '미드세일' ? '?midSale=true&sort=popularity&page=0' : category?.categoryName === '시즌오프' ? '?sale=true' : ''}`
                  )
              }>
              {/*{category?.categoryName !== '미드세일' ? '신상품' : '전체'}*/}
              {category?.categoryName == '남성' || category?.categoryName == '여성' ? '신상품' : '전체'}
            </div>
          </>
      )}
      {open &&
        subs.sort((a, b) => b.sort - a.sort).map((item, index) => (
          <div
            className="border-b py-4 ml-8"
            key={index}
            onClick={() =>
              history.replace(
                `/p/${category.categoryName}/${category.categoryId}/${item.subcategoryId}/${category?.categoryName === '미드세일' && '?midSale=true&sort=popularity&page=0'}`,
              )
            }>
            {item.name}
          </div>
        ))}
      {/*{(open && category?.categoryName !== '미드세일') && (*/}
      {
        (open && (category?.categoryName == '남성' || category?.categoryName == '여성')) &&
          (
              <div
                  className="border-b py-4 ml-8 text-red"
                  onClick={() => history.replace(`/p/${category.categoryName}/${category.categoryId}?sale=true`)}>
                <p className="text-13 text-red-500 font-normal">세일</p>
              </div>
          )
      }
    </>
  );
};

export default MobileCategoryItem;
